import { ChangeDetectorRef } from '@angular/core';
import { Observable, tap } from 'rxjs';

/**
 * Schedules change detection for the component owning `cdRef` whenever the
 * source observable emits, errors or completes.
 *
 * The application runs without zone.js, so state that is updated from an
 * observable callback (HTTP, store, dialogs, timers, sockets) is not rendered
 * unless change detection is scheduled explicitly. `markForCheck()` only
 * schedules a tick, which runs after the subscriber callback has updated the
 * component state.
 */
export function markForCheckOn(cdRef: ChangeDetectorRef): <T>(source: Observable<T>) => Observable<T> {
  const schedule = () => cdRef.markForCheck();
  return <T>(source: Observable<T>) =>
    source.pipe(tap<T>({ next: schedule, error: schedule, complete: schedule }));
}
